import React from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { logoutSystem } from 'utils/functions';
import { LogoutModalProps } from 'types/LogoutModal';
import { useTranslation } from 'react-i18next';

export default function LogoutModal({
	open = false,
	setOpen = () => null
}: LogoutModalProps) {
	const { t }: any = useTranslation();

	return (
		<Modal
			isOpenProps={open}
			setIsOpenModal={setOpen}
			buttonClose={false}
			paddingChildren={false}
			title={t('logoutModal.logout')}
		>
			<S.container>
				<S.message>
					<p>{t('logoutModal.message')}</p>
				</S.message>

				<S.line />
				<S.btns>
					<S.yesBtn onClick={() => logoutSystem()}>
						{t('logoutModal.yes')}
					</S.yesBtn>
					<S.noBtn onClick={() => setOpen(false)}>
						{t('logoutModal.no')}
					</S.noBtn>
				</S.btns>
			</S.container>
		</Modal>
	);
}
